import { ApiCall } from "common/types/api";

export const starredApi = (apiCall: ApiCall) => ({
  star: (site: string, entity: string, id: string) =>
    apiCall("post", `/api/ui/starred/${site}/${entity}/${id}`),
  unstar: (site: string, entity: string, id: string) =>
    apiCall("delete", `/api/ui/starred/${site}/${entity}/${id}`),
});
